<template>
    <div class="documents-style">
        <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>

        <div class="row no-gutters py-2 mb-3">

            <div class="col-sm-5 company-form-box-title">
                <div class="custom-search">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search for tax documents " v-model="search"
                            @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-sm-7 cursor-pointer text-right company-form-box-title">
                <template>
                    <b-button @click="addNew(0)">+ Add Document</b-button>
                    <b-button @click="addNew(1)" v-if="flg == 1">Request Document</b-button>
                </template>
                <b-button @click="downloadSelected()">Download Selected</b-button>
                <!-- Signature Modal With Button Starts Here -->
                <b-button v-b-modal.bv-modal-employee-signature>Signature</b-button>
                <b-modal id="bv-modal-employee-signature" size="lg" :modal-class="'w-600'" no-close-on-backdrop
                    hide-footer title="Employee Signature">
                    <employee-signature v-on:childToParent="hideSignaturePad"></employee-signature>
                </b-modal>
                <!-- Signature Modal With Button Ends Here -->
            </div>
        </div>


        <div class="">
            <table class="table dataTable">
                <thead>
                    <tr class="table-head">
                        <td class="checkbox-col text-center">
                            <input type="checkbox" v-model="checkall" @click="selectAll()" />
                            <!-- <label></label> -->
                        </td>
                        <th>Name</th>
                        <th>Type</th>
                        <th class="file">File</th>
                        <th class="file">Signed File</th>
                        <th class="action">Action</th>
                    </tr>
                </thead>
                <!-- alpha fix added this template with condition for blank text  -->
                <template v-if="documents.length > 0 || available_fiscal_year.length > 0">
                    <tbody class="table-body">
                        <tr class="hover-bg table-row border-bottom mx-2" v-for="doc in documents" :key="doc.id">
                            <td class="checkbox-col text-center">
                                <input type="checkbox" class="checkall_tax justify-content-center"
                                    v-if="doc.file_name != ''" v-model="checked_list" :value="'uploaded:' + doc.id" />
                                <!-- <label></label> -->
                            </td>
                            <td>{{ doc.name }}</td>
                            <td>{{ types[doc.type].text }}</td>
                            <td class="file">
                                <div class="" v-if="doc.file_name != ''">

                                    <div class="align-self-center" style="vertical-align: middle;">
                                        <b-link @click="downloadFileContent(doc.file_name)">
                                            <img :src="$api_url + '/images/download_image.png'" class="" />
                                        </b-link>

                                    </div>

                                    <div class="align-self-center" style="vertical-align: middle;">
                                        <template
                                            v-if="(doc.flg == 1) && (doc.submit_with_in != null) && (doc.submit_with_in != '0000-00-00')">
                                            <span v-if="checkPastDate(doc.submit_with_in) == true"
                                                class="text-danger td-5-span">Requested (Upload by
                                                {{ doc.submit_with_in }})</span>
                                            <span class="ml-4" v-else>Requested (Upload by
                                                {{ doc.submit_with_in }})</span>
                                        </template>
                                    </div>
                                </div>
                                <div
                                    v-else-if="(doc.flg == 1) && (doc.submit_with_in != null) && (doc.submit_with_in != '0000-00-00')">
                                    <span v-if="checkPastDate(doc.submit_with_in) == true"
                                        class="text-danger td-5-span">Requested (Upload by
                                        {{ doc.submit_with_in }})</span>
                                    <span v-else>Requested (Upload by {{ doc.submit_with_in }})</span>
                                </div>
                                <div v-else>No file uploaded</div>
                            </td>
                            <td class="file">
                            </td>

                            <td class="float-right action" v-if="flg > 0 && doc.type < 3">
                                <div class="position-relative" v-if="doc.type > 1">
                                    <b-button-toolbar>
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                            style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false"><b-icon
                                                icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu position_absolute"
                                            aria-labelledby="actionDropdown">
                                            <b-button-group>
                                                <b-button variant="outline-secondary" @click="editDocument(doc.id)">
                                                    <b-icon icon="pencil"></b-icon> Upload
                                                </b-button>
                                                <b-button variant="outline-secondary" @click="deleteDocument(doc.id)"
                                                    v-if="flg == 1">
                                                    <b-icon icon="trash"></b-icon> Delete
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                </div>
                                <div class="position-relative" v-else>
                                    <b-button-toolbar>
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                            style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false"><b-icon
                                                icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu position_absolute"
                                            aria-labelledby="actionDropdown">
                                            <b-button-group>
                                                <b-button variant="outline-secondary"
                                                    @click="editFixedDocument(doc.type, doc.id)">
                                                    <b-icon icon="pencil"></b-icon> Upload
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                </div>
                            </td>
                        </tr>

                        <template v-for="fiscal_year in available_fiscal_year">
                            <tr class="hover-bg table-row border-bottom mx-2">
                                <td class="text-center"><input class="checkall_tax" type="checkbox"
                                        v-model="checked_list" :value="'investment:' + fiscal_year" /></td>
                                <td>Investment Declaration Letter - {{ fiscal_year }}</td>
                                <td>Investment Declaration Letter</td>
                                <td class="file">
                                    <div class="">
                                        <b-link @click="generateDoc(3, fiscal_year)">
                                            <img :src="$api_url + '/images/download_image.png'" class="" />
                                        </b-link>

                                    </div>
                                </td>
                                <td class="file">
                                    <template v-if="fars[fiscal_year] != undefined">
                                        <div class="" v-if="fars[fiscal_year]['3'].file != ''">
                                            <div class="align-self-center" style="vertical-align: middle;">
                                                <b-link @click="downloadFileContent(fars[fiscal_year]['3'].file)">
                                                    <img :src="$api_url + '/images/download_image.png'" class="" />
                                                </b-link>
                                            </div>
                                            <div class="align-self-center" style="vertical-align: middle;">
                                                <template
                                                    v-if="(fars[fiscal_year]['3'].flg == 1) && (fars[fiscal_year]['3'].submit_with_in != null) && (fars[fiscal_year]['3'].submit_with_in != '0000-00-00')">
                                                    <span
                                                        v-if="checkPastDate(fars[fiscal_year]['3'].submit_with_in) == true"
                                                        class="text-danger td-5-span">Requested (Upload by
                                                        {{ fars[fiscal_year]['3'].submit_with_in }})</span>
                                                    <span class="ml-4" v-else>Requested (Upload by
                                                        {{ fars[fiscal_year]['3'].submit_with_in }})</span>
                                                </template>
                                            </div>
                                        </div>
                                        <div
                                            v-else-if="(fars[fiscal_year]['3'].flg == 1) && (fars[fiscal_year]['3'].submit_with_in != null) && (fars[fiscal_year]['3'].submit_with_in != '0000-00-00')">
                                            <span v-if="checkPastDate(fars[fiscal_year]['3'].submit_with_in) == true"
                                                class="text-danger td-5-span">Requested
                                                (Upload by {{ fars[fiscal_year]['3'].submit_with_in }})</span>
                                            <span v-else>Requested (Upload by
                                                {{ fars[fiscal_year]['3'].submit_with_in }})</span>
                                        </div>
                                        <div v-else>No file uploaded</div>

                                    </template>
                                </td>
                                <td class="float-right action">
                                    <div class="position-relative">
                                        <b-button-toolbar>
                                            <a id="actionDropdown"
                                                class="dropdown-toggle clearfix action-dropdown-toggle"
                                                style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false"><b-icon
                                                    icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu"
                                                aria-labelledby="actionDropdown">
                                                <b-button-group>
                                                    <b-button variant="outline-secondary"
                                                        @click="addSignature(3, fiscal_year)">
                                                        <b-icon icon="pencil"></b-icon> Upload
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </div>
                                </td>

                            </tr>

                            <tr class="hover-bg table-row border-bottom mx-2">
                                <td class="text-center"><input type="checkbox" class="checkall_tax"
                                        v-model="checked_list" :value="'incometax:' + fiscal_year" /></td>
                                <td>Income Tax Deduction Certificate - {{ fiscal_year }}</td>
                                <td>Income Tax Deduction Certificate</td>
                                <td class="file">
                                    <div class="">
                                        <b-link @click="generateDoc(4, fiscal_year)">
                                            <img :src="$api_url + '/images/download_image.png'" class="" />
                                        </b-link>
                                    </div>
                                </td>
                                <td class="file">
                                </td>
                                <td class="action">
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </template>

                <!-- alpha fix -added this  -->
                <template v-else>
                    <tbody class="table-body">
                        <tr class="hover-bg table-row">
                            <td class="cursor-pointer trz_relative text-center" colspan="6">{{ blankmsg }}</td>
                        </tr>
                    </tbody>
                </template>

            </table>
        </div>




        <b-modal id="bv-modal-tax-documents" size="lg" :modal-class="'w-600'" no-close-on-backdrop hide-footer
            title="Tax Documents" v-if="flg > 0">

            <ul>
                <li clase="text-uppercase" v-for='data in errormsg'>{{ data[0] }}</li>
            </ul>
            <b-overlay :show="showoverlay" rounded="sm" class="trz_overlay_custom">
                <b-form @submit.stop.prevent="onSubmit">
                    <input type="hidden" v-model="fdata.id" name="id">
<!-- alpha fix- added class required-field  -->
                    <b-form-group id="name-group" label="Name" class="required-field" label-for="name">
                        <b-form-input id="name" name="name" :disabled="disable_me" v-model="fdata.name"
                            v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                            aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                        <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                        }}</b-form-invalid-feedback>
                    </b-form-group>
<!-- alpha fix- added class required-field  -->
                    <b-form-group id="type-group" class="required-field" label="Type" label-for="type">
                        <template v-if="this.type_text.length > 0">
                            <b-form-input :value="type_text" :disabled="disable_me"></b-form-input>
                        </template>

                        <template v-else>
                            <b-form-select id="type" name="type" v-model="fdata.type" v-validate="{ required: true }"
                                :options="(flg == 1) ? systemtypes : types_options_final" @change="checkType()"
                                :state="validateState('type')" aria-describedby="type-feedback"
                                data-vv-as="Type"></b-form-select>
                            <b-form-invalid-feedback id="type-feedback">{{ veeErrors.first('type')
                            }}</b-form-invalid-feedback>
                        </template>
                    </b-form-group>


                    <b-form-group v-if="fdata.type == 3" id="fiscal_year-group" label="Fiscal Year"
                        class="required-field" label-for="fiscal_year">
                        <b-form-select id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year"
                            v-validate="{ required: true }" :options="available_fiscal_year"
                            :state="validateState('fiscal_year')" aria-describedby="fiscal_year-feedback"
                            data-vv-as="Fiscal Year"></b-form-select>
                        <b-form-invalid-feedback id="fiscal_year-feedback">{{ veeErrors.first('fiscal_year')
                        }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="upload_file-group" label="File" label-for="upload_file" v-if="request == 0">
                        <b-form-file id="upload_file" v-model="upload_file"
                        @change="checkFileType($event, 'upload_file', ['.jpg', '.png', '.gif', '.pdf', '.doc', '.docx'])"
                            accept=".jpg, .png, .gif, .pdf , .doc , .docx"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."></b-form-file>

                    </b-form-group>

                    <b-form-group id="submit_with_in-group" label="Deadline [YYYY-MM-DD] - Optional"
                        label-for="submit_with_in" class="mt-4" v-if="this.flg == 1">
                        <b-input-group class="mb-3">
                            <b-form-input id="submit_with_in" name="submit_with_in" v-model="fdata.submit_with_in"
                                type="text" placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                            <b-input-group-append class="btn-radius-8">
                                <b-form-datepicker id="submit_with_in" button-only right locale="en-US"
                                    v-model="fdata.submit_with_in" :min="date_min"></b-form-datepicker>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>

                    <b-form-group label=" " class="text-center">
                        <b-button class="ml-2 btn-primary custom-wizard-btn" @click="resetForm()">Reset</b-button>
                        <b-button class="btn-primary" type="submit" variant="primary">Submit</b-button>
                    </b-form-group>
                </b-form>
            </b-overlay>
        </b-modal>

        <b-modal id="bv-modal-add-signature" size="lg" :modal-class="'w-600'" no-close-on-backdrop hide-footer
            :title="signed_for">
            <b-overlay :show="showoverlay" rounded="sm" class="trz_overlay_custom">
                <b-form @submit.stop.prevent="saveSignedDoc">

                    <template v-if="signature_url == null">
                        <div class="alert alert-info">It seems like you do not have any digital signature added into the
                            system. Please click <span class="alert-success"
                                v-b-modal.bv-modal-employee-signature>here</span> if you wish to add digital signature
                            which you will be able to use throughout the system.</div>
                    </template>
                    <template v-else>
                        <b-form-group id="use_saved_signature-group" label-for="use_saved_signature">
                            <b-form-checkbox id="use_saved_signature" v-model="use_saved_signature"
                                name="use_saved_signature">
                                Use Saved Signature
                            </b-form-checkbox>
                        </b-form-group>
                    </template>

                    <template v-if="use_saved_signature == false">
                        <div class="trz_heading">OR</div>
                        <b-form-group id="upload_file-group" label="Upload Signed Document" label-for="upload_file">
                            <b-form-file id="upload_file" v-model="upload_file"
                                accept=".jpg, .png, .gif, .pdf , .doc , .docx"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."></b-form-file>
                        </b-form-group>

                    </template>

                    <div clase="clearfix text-center">
                        <div class=""><b-button type="submit" variant="primary" clase="col-4">Submit</b-button></div>
                        <div class=" ml-2 mt-1"><b-form-checkbox id="agree" :state='agree' v-model="agree"
                                name="agree">I agree
                                to use my signature for the documents uploaded to accordHRM</b-form-checkbox></div>
                    </div>


                </b-form>
            </b-overlay>
        </b-modal>




    </div>
</template>


<script>
export default {


    props: ['flg'],
    data() {

        let sortOrders = {};
        let columns = [
            { label: 'Name', name: 'name' },
            { label: 'Type', name: 'type' },
            { label: '', name: 'created_at' },

        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const minDate = new Date(today);

        return {

            date_min: minDate,
            checked_list: [],
            checkall: false,

            existing_types: [],
            documents: [],
            successmsg: null,
            errormsg: [],
            showoverlay: false,
            fdata: { id: null, name: null, submit_with_in: null, type: "2" },
            upload_file: null,
            disable_me: false,
            types: [
                { value: null, text: "Select..." },
                { value: "1", text: "eTIN" },
                { value: "2", text: "AIT Challan" },
                // { value: "3", text: "Investment Declaration Letter" },
                // { value: "4", text: "Income Tax Deduction Certificate" },
            ],
            systemtypes: [{ value: null, text: "Select..." }],

            types_options: [],
            types_options2: [

                { value: "1", text: "eTIN" },
                { value: "2", text: "AIT Challan" },
                { value: "3", text: "Investment Declaration Letter" },
            ],
            types_options_final: [

            ],

            type_text: '',
            request: 0,

            blankmsg: 'Fetching data..',
            search: '',

            sdata: { type: null, fiscal_year: null },
            fars: [],
            signed_for: '',
            use_saved_signature: false,
            signature_url: null,
            agree: false,
            available_fiscal_year: [],

        }
    },
    methods: {
        getSignature: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/employee/singature').then(function (response) {
                if (response.data.length > 0) {
                    this.signature_url = response.data;
                    //this.use_saved_signature = true;
                }

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        getAvailableFiscalYear: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/get-employee-fiscal-year').then(function (response) {
                if (response.data.length > 0) {
                    this.available_fiscal_year = response.data;
                }

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        downloadSelected: function () {
            if (this.checked_list.length == 0) {
                this.$bvToast.toast('No document selected.', {
                    title: `Warning`,
                    variant: 'warning',
                    solid: true
                });

                return false;
            }

            if (!this.checkNet()) return false;
            let currentObj = this;

            let url = '';
            url = this.$api_url + '/documents/zip/download';

            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });

            let formData = new FormData();

            formData.append('checked_list', this.checked_list);
            formData.append('type', 'tax');

            axios.post(url, formData)
                .then(function (response) {
                    this.downloadFileContent('' + response.data);

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        selectAll: function () {
            this.checkall = !this.checkall;
            var y = document.getElementsByClassName("checkall_tax");
            var i;
            for (i = 0; i < y.length; i++) {
                if (y[i].checked != this.checkall)
                    y[i].click();
            }
        },
        checkType: function () {
            if ((this.fdata.type == 1) && (this.fdata.id == null)) {
                this.fdata.name = 'eTin';
                this.disable_me = true;
            }
            else {
                if (this.fdata.id == null) {
                    this.disable_me = false;
                    this.fdata.name = '';
                }
            }
        },
        generateDoc: function (type, fiscal_year = '2021-2022') {
            if (!this.checkNet()) return false;
            let currentObj = this;

            let url = '';
            if (type == 4) url = this.$api_url + '/incometax/deductioncertificate';
            else if (type == 3) url = this.$api_url + '/investmentallowance/declaration';

            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });

            let formData = new FormData();

            formData.append('fiscal_year', fiscal_year);

            axios.post(url, formData)
                .then(function (response) {
                    this.downloadFileContent('' + response.data);

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        hideSignaturePad: function () {
            setTimeout(function () { this.$bvModal.hide('bv-modal-employee-signature'); }.bind(this), 1000);
        },

        getDocumentList: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/tax-document', {
                params: {

                }
            }).then(function (response) {
                //this.documents = response.data;
                this.documents = response.data.list;
                this.fars = response.data.signed;

                this.types_options = response.data.types_options;



                if (this.types_options.hasOwnProperty(1)) {
                    const newItems = [{ value: "1", text: "eTin" }];
                    this.systemtypes = [...this.systemtypes, ...newItems];
                }
                if (this.types_options.hasOwnProperty(2)) {
                    const newItems = [{ value: "2", text: "AIT Challan" }];
                    this.systemtypes = [...this.systemtypes, ...newItems];
                }


                // const newItems = [{ value: "3", text: "Investment Declaration Letter" },{ value: "4", text: "Income Tax Deduction Certificate" }];
                // this.systemtypes = [...this.systemtypes, ...newItems];

                if (this.documents.length == 0)
                    this.blankmsg = "No Tax Documents Found";

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editFixedDocument: function (x, y) {
            if (x == 1) this.fdata.name = "eTin";

            this.editDocument(y)
            this.fdata.type = x;
            //this.fdata.id = null;

            if (x == 1) this.fdata.name = "eTin";

            this.type_text = this.fdata.name;
            this.disable_me = true;
        },
        editDocument: function (x) {

            if (!this.checkNet()) return false;
            let currentObj = this;
            //this.type_text = 'pp';

            axios.get(this.$api_url + '/tax-document/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;
                this.type_text = this.types[this.fdata.type].text;
                if (this.fdata.type == 1)
                    this.disable_me = true;
                else
                    this.disable_me = false;

                this.$validator.reset();
                this.request = 0;

                this.$bvModal.show('bv-modal-tax-documents');

            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });

        },
        addSignature: function (type, fiscal_year) {
            if (!this.checkNet()) return false;

            this.sdata.type = type;
            this.sdata.fiscal_year = fiscal_year;

            if (type == 3)
                this.signed_for = 'Upload Signed Document of Investment Declaration Letter for the year of ' + fiscal_year;
            else
                this.signed_for = 'Upload Signed Document of Income Tax Deduction Certificate for the year of ' + fiscal_year;

            this.upload_file = null;
            this.agree = false;
            this.$bvModal.show('bv-modal-add-signature');

        },
        saveSignedDoc() {

            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                if (this.agree == false) return;
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                this.showoverlay = true;

                let formData = new FormData();

                if (this.use_saved_signature == true) {
                    formData.append('use_saved_signature', 1);
                }
                else {

                    formData.append('use_saved_signature', 0);

                    if (this.upload_file)
                        formData.append('upload_file', this.upload_file);
                    else {
                        return;
                    }
                }


                for (let [key, value] of Object.entries(this.sdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/tax-document/signeddoc', formData, config)
                    .then(function (response) {
                        currentObj.getDocumentList();

                        currentObj.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        currentObj.showoverlay = false;
                        currentObj.$bvModal.hide('bv-modal-add-signature');

                    }.bind(this))
                    .catch(function (error) {
                        console.log(error);
                        // this.showoverlay = false;
                        //currentObj.serverError(error);
                        //.errormsg = error.response.data.errors;
                    });

            });
        },
        deleteDocument(id) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this work location.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {

                        this.showoverlay = true;
                        let formData = new FormData();
                        formData.append('id', id);

                        axios.post(this.$api_url + '/tax-document/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                                this.getDocumentList();

                            }
                            else {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Warning`,
                                    variant: 'warning',
                                    solid: true
                                });
                            }

                            this.resetPagination();
                            this.showoverlay = false;

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.showoverlay = false;
                                currentObj.serverError(error);
                            });
                    }
                })
                ;
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { id: null, name: '', type: null, submit_with_in: null };
            this.upload_file = null;
            this.disable_me = false;
            this.type_text = '';

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addNew(x) {
            this.resetForm();
            if (x == 1) {
                this.types_options_final = this.types_options2;
                this.fdata.flg = 1;
                this.request = 1;
            }
            else {
                this.types_options_final = this.types_options;
                this.fdata.flg = 0;
                this.request = 0;
            }
            this.$bvModal.show('bv-modal-tax-documents');
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;


            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }


                if (this.fdata.submit_with_in != 'undefined' && this.fdata.submit_with_in != null && this.fdata.id == 0) {

                    if (this.fdata.submit_with_in != null) {
                        let submit_with_in = this.fdata.submit_with_in.split('-');
                        const submit_with_in_date = new Date(submit_with_in[0], submit_with_in[1] - 1, submit_with_in[2]);
                        const submit_with_in_date_final = new Date(submit_with_in_date);



                        const now2 = new Date()
                        const today2 = new Date(now2.getFullYear(), now2.getMonth(), now2.getDate())
                        const currentDate = new Date(today2);

                        if (currentDate.getTime() > submit_with_in_date_final.getTime()) {
                            this.showoverlay = false;
                            this.$bvToast.toast('Deadline cannot be an older date !', {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });

                            return;

                        }

                    }

                }

                let formData = new FormData();

                if (this.upload_file)
                    formData.append('upload_file', this.upload_file);

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                formData.append('updated_by', this.flg);

                axios.post(this.$api_url + '/tax-document/details', formData, config)
                    .then(function (response) {
                        //console.log(response.data);
                        this.getDocumentList();

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.showoverlay = false;
                        this.resetForm();

                        this.$bvModal.hide('bv-modal-tax-documents');

                    }.bind(this))
                    .catch(function (error) {
                        this.showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },

    },
    created: function () {
        this.getAvailableFiscalYear();
        this.getDocumentList();
        this.getSignature();
    },
}
</script>
